
    const data = {"name":"src/core/icons/account-hard-hat","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 15c-4.42 0-8 1.79-8 4v2h16v-2c0-2.21-3.58-4-8-4M8 9a4 4 0 0 0 4 4 4 4 0 0 0 4-4m-4.5-7c-.3 0-.5.21-.5.5v3h-1V3s-2.25.86-2.25 3.75c0 0-.75.14-.75 1.25h10c-.05-1.11-.75-1.25-.75-1.25C16.25 3.86 14 3 14 3v2.5h-1v-3c0-.29-.19-.5-.5-.5h-1Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            